<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="visible"
      :style="{ width: $isMobile() ? '100vw' : '60vw' }"
      :header="form.id ? 'Editar Equipamento' : 'Adicionar Equipamento'"
      modal
    >
      <form @submit.prevent="submit" ref="form">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label>Marca</label>
            <InputText
              v-model="form.brand"
              name="brand"
              v-validate="'required|max:100'"
              :class="{ 'p-invalid': errors.has('brand') }"
            />
            <span v-if="errors.has('brand')" class="p-error"
              >Marca é Obrigatório</span
            >
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Modelo</label>
            <InputText
              v-model="form.model"
              name="model"
              v-validate="'required|max:100'"
              :class="{ 'p-invalid': errors.has('model') }"
            />
            <span v-if="errors.has('model')" class="p-error">
              Modelo é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Número de Série</label>
            <InputText
              v-model="form.serialNumber"
              name="serialNumber"
              v-validate="'required|max:100'"
              :class="{ 'p-invalid': errors.has('serialNumber') }"
              autocomplete="off"
            />
            <span v-if="errors.has('serialNumber')" class="p-error">
              Número de Série é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Data de Compra</label>
            <Calendar
              v-model="form.purchaseDate"
              name="purchaseDate"
              v-validate="'required'"
              :showButtonBar="true"
              dateFormat="dd-mm-yy"
              placeholder="Selecione a data"
              :class="{ 'p-invalid': errors.has('purchaseDate') }"
              autocomplete="off"
              appendTo="body"
            />
            <span v-if="errors.has('purchaseDate')" class="p-error">
              Data de Compra é Obrigatório
            </span>
          </div>

          <div class="p-field p-col-12 p-md-4 p-mt-4">
            <AppAutocomplete
              label="Cliente"
              fieldId="customerId"
              :optionLabel="getClientLabel"
              optionValue="compositeKey"
              v-model="form.clientCompositeKey"
              :editModel="getCurrentClient"
              :fetchFunction="fetchClients"
              v-validate.disable="'required'"
              data-vv-name="customerId"
              placeholder="Selecione o Cliente"
              @selection-change="clientChange"
              @clear-selection="clearClient"
              appendTo="body">
              <template #option="slotProps">
                <div>
                  <b>{{ slotProps.option.name }}</b>
                  <br />
                  <span style="white-space: normal; word-break: break-word;">
                    <span v-if="slotProps.option.email">EMAIL: {{ slotProps.option.email }} | </span>
                    <span v-if="slotProps.option.fiscalNumber">NIF: {{ slotProps.option.fiscalNumber }} | </span>
                    <span v-if="slotProps.option.telephone">TEL.: {{ slotProps.option.telephone }} | </span>
                    <span v-if="slotProps.option.mobilPhone">TELM.: {{ slotProps.option.mobilPhone }}</span>
                  </span>
                </div>
              </template>
            </AppAutocomplete>
            <span v-if="errors.has('customerId')" class="p-error">
              Cliente é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Situação</label>
            <Dropdown
              v-model="form.status"
              name="status"
              v-validate="'required|max:100'"
              :options="statusList"
              filter
              dataKey="id"
              optionLabel="name"
              optionValue="name"
              placeholder="Selecione o Estado"
              :class="{ 'p-invalid': errors.has('status') }"
              appendTo="body"
            />
            <span v-if="errors.has('status')" class="p-error">
              Situação é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Observações</label>
            <Textarea
              v-model="form.observation"
              name="observation"
              v-validate="'max:1000'"
              :class="{ 'p-invalid': errors.has('observation') }"
              rows="3"
              autoResize
            />
            <span v-if="errors.has('observation')" class="p-error">{{
              errors.first("observation")
            }}</span>
          </div>
        </div>
      </form>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
        <Button
          label="Guardar"
          class="p-button-success"
          icon="pi pi-save"
          @click="submit"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import EquipmentService from "@/services/equipment.service";
import Calendar from "primevue/calendar";
import ClientService from "@/services/client.service";
import AppAutocomplete from "@/components/elements/AppAutocomplete.vue";
import { getOnlyDate, parseUserDate } from "@/helpers/helpers";
export default {
  name: "EquipmentModal",
  components: { Calendar, AppAutocomplete },
  props: {
    visible: Boolean,
    data: Object,
  },
  data() {
    return {
      form: {},
      statusList: [],
    };
  },
  watch: {
    async visible() {
      this.reset();
      if (this.visible === true) {
        this.$validator.resume();
        this.form = { ...this.data };
        if (this.form.id && this.form.clientId) {
          this.form.clientCompositeKey = `${this.form.clientId}-${this.form.estab ?? 0}`;
          this.form.clientEstab = this.form.estab ?? 0;
        }
      }
    },
  },
  async created() {
    this.statusList = await EquipmentService.status();
  },
  methods: {
    getClientLabel(client) {
      if (!client) return '';
      return `${client.name} | EMAIL: ${client.email} | NIF: ${client.fiscalNumber} | TEL.: ${client.telephone} | TELM.: ${client.mobilPhone}`;
    },
    async fetchClients(search = '') {
      try {
        let clients = await ClientService.query({ search });
        return clients.map(c => ({
          ...c,
          compositeKey: `${c.id}-${c.estab}`
        }));
      } catch (error) {
        return [];
      }
    },
    async getCurrentClient(compositeValue) {
      try {
        const id = compositeValue?.includes('-') ? compositeValue.split('-')[0] : compositeValue;
        const estab = compositeValue?.includes('-') ? compositeValue.split('-')[1] : 0;
        let response = await ClientService.query({ no: id, estab: estab });
        if (!response.length) return null;
        return { ...response[0], compositeKey: `${response[0].id}-${response[0].estab}` };
      } catch (error) {
        return null;
      }
    },
    clientChange(compositeValue) {
      if (!compositeValue) return;
      const [id, estab] = compositeValue.split('-');
      this.form.clientId = id;
      this.form.clientEstab = estab;
    },
    clearClient() {
      this.form.clientId = null;
      this.form.clientCompositeKey = null;
    },
    reset() {
      this.form = {
        id: null,
        status: "",
        serialNumber: "",
        brand: "",
        model: "",
        clientId: "",
        clientEstab: 0,
        clientCompositeKey: null,
        purchaseDate: null,
        observation: "",
      };
      this.$validator.pause();
      this.$validator.reset();
    },
    cancel() {
      this.$validator.pause();
      this.$validator.reset();
      this.reset();
      return this.$emit("cancel");
    },
    async submit() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }

      let payload = {
        status: this.form.status,
        serialNumber: this.form.serialNumber,
        brand: this.form.brand,
        model: this.form.model,
        customerId: this.form.clientId,
        customerEstab: this.form.clientEstab,
        observation: this.form.observation,
      };
      if (this.form.purchaseDate) {
        if (this.form.purchaseDate instanceof Date) {
          payload.purchaseDate = getOnlyDate(this.form.purchaseDate);
        } else {
          payload.purchaseDate = parseUserDate(this.form.purchaseDate);
        }
      }
      this.$validator.pause();
      this.$validator.reset();
      if (this.form.id) {
        return await EquipmentService.update(this.form.id, payload).then((response) => {
            if (!response) {
              return this.$toast.add({
                severity: "error",
                summary: `Erro ao Atualizar Equipamento`,
                detail: "",
                life: 3000,
              });
            }
            this.$toast.add({
              severity: "success",
              summary: `Equipamento Atualizado`,
              detail: "",
              life: 3000,
            });
            return this.$emit("updated", response);
          });
      } else {
        return EquipmentService.create(payload).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Criar Equipamento`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Equipamento Criado`,
            detail: "",
            life: 3000,
          });
          return this.$emit("created", response);
        });
      }
    },
  },
};
</script>
